import { useTree } from "components/common/Tree";
import useHealthModule from "./useHealthModule";
import useHealthModuleVisible from "./useHealthModuleVisible";
import useHealthReportViewMode from "./useHealthReportViewMode";
import useHealthSelection from "./useHealthSelection";
import useInitialCheckParam from "./useInitialCheckParam";
const useHealthPanel = () => {
  const showHealthModule = useHealthModuleVisible();
  const initialCheck = useInitialCheckParam();
  const [viewMode, setViewMode] = useHealthReportViewMode(initialCheck);
  const problemsOnly = viewMode === "problems";
  const { error, generatedAt, hasReport, initialExpandedState, isFetching, isLoading, lookup, paths, root, treeData } = useHealthModule({ problemsOnly });
  const tree = useTree({
    initialExpandedState,
    initialSelectedState: [initialCheck != null ? initialCheck : root.id]
  });
  const { selectedNode, selectedPath, isRootSelected } = useHealthSelection(
    tree,
    root,
    lookup,
    paths,
    hasReport,
    viewMode,
    initialCheck
  );
  const hasNoVisibleProblems = problemsOnly && hasReport && root.status === "healthy" && root.children.length === 0;
  const hasHardFailure = !!error && !hasReport;
  return {
    showHealthModule,
    viewMode,
    setViewMode,
    problemsOnly,
    error,
    generatedAt,
    hasReport,
    isFetching,
    isLoading,
    lookup,
    root,
    treeData,
    tree,
    selectedNode,
    selectedPath,
    isRootSelected,
    hasNoVisibleProblems,
    hasHardFailure
  };
};
export default useHealthPanel;
